import React, {Component} from 'react';
import styled from "styled-components";

import Screen from '../components/Screen';
import Content from '../components/Content';
import Card from '../components/Card';
import Form from '../components/Form';
import Input from '../components/Input';
import Button from '../components/Button';

class CodeGeneratorScreen extends Component {
  state = {
    type: 'UUID',
    number: 1,
    perRow: 4,
    scale: 1,
    static: '',
    prefix: '',
    initial: 0,
    advanced: false,
    description: ''
  }

  generate() {
    const query = Object.keys(this.state).map(k => (`${k}=${this.state[k]}`)).join('&');
    window.open(`/codes/print?${query}`, '_blank');
  }

  render() {
    return(
      <Screen title="Generate QR Codes" activeLink="generateCodes" showTitle={true}>
        <Content>
          <CardContainer>
            <Card.Content>
              <Form onSubmit={() => this.generate()}>
                <Form.Group>
                  <Input
                    id="type"
                    type="select"
                    label="Generated Code Type"
                    value={this.state.type}
                    onChange={e => this.setState({type: e.target.value})}>
                        <option id={"TYPE_UUID"} value={"UUID"}>UUID</option>
                        <option id={"TYPE_INCREMENT"} value={"INCREMENT"}>INCREMENT</option>
                        <option id={"TYPE_STATIC"} value={"STATIC"}>STATIC VALUE</option>
                  </Input>
                </Form.Group>
                <Form.Group>
                  <Input
                    id="number"
                    type="number"
                    label="How Many"
                    value={this.state.number.toString()}
                    onChange={e => this.setState({number: Math.max(Math.floor(Number(e.target.value)), 1)})}
                    />
                </Form.Group>
                { this.state.type === 'INCREMENT' && (
                  <>
                    <Form.Group>
                      <Input
                        id="prefix"
                        type="text"
                        label="Prefix"
                        value={this.state.prefix}
                        onChange={e => this.setState({prefix: e.target.value})}
                        />
                    </Form.Group>
                    <Form.Group>
                      <Input
                        id="inital"
                        type="number"
                        label="Starting from"
                        value={this.state.initial.toString()}
                        onChange={e => this.setState({initial: Math.floor(Number(e.target.value))})}
                        />
                    </Form.Group>
                  </>
                )}
                { this.state.type === 'STATIC' && (
                  <Form.Group>
                    <Input
                      id="static"
                      type="text"
                      label="Value"
                      value={this.state.static}
                      onChange={e => this.setState({static: e.target.value})}
                      />
                  </Form.Group>
                )}
                { this.state.advanced && (
                  <>
                  <Form.Group>
                    <Input
                      id="description"
                      type="text"
                      label="Some static description"
                      value={this.state.description}
                      onChange={e => this.setState({description: e.target.value})}
                      />
                  </Form.Group>
                    <Form.Group>
                      <Input
                        id="perRow"
                        type="number"
                        label="Generate in Rows of"
                        value={this.state.perRow.toString()}
                        onChange={e => this.setState({perRow: Math.max(Math.floor(Number(e.target.value)), 1)})}
                        />
                    </Form.Group>
                    <Form.Group>
                      <Input
                        id="scale"
                        type="number"
                        label="Scale final image by"
                        value={this.state.scale.toString()}
                        onChange={e => this.setState({scale: Math.max(Number(e.target.value), 0)})}
                        />
                    </Form.Group>
                  </>
                )}
                <ButtonGroup>
                    <Button type="submit">Submit</Button>
                    <Button tertiary onClick={() => this.setState({advanced: !this.state.advanced})}>
                      { this.state.advanced ? "Hide" : "Show" } advanced options
                    </Button>
                </ButtonGroup>
              </Form>
            </Card.Content>
          </CardContainer>
        </Content>
      </Screen>
    )
  }
}

const CardContainer = styled(Card)`
  margin-bottom: 2rem;
`;

const ButtonGroup = styled(Form.Group)`
  Button {
    margin-right: 10px;
  }
`

export default CodeGeneratorScreen;